/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { InlineEditableColumnPrompt } from '@bingads-webui-campaign/summary-grid-helper';
import { Campaign } from '@bingads-webui-campaign/campaign-ui-schemas';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import PageContext from '@bingads-webui-static-legacy/page-context';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { manualCpcInlineEditorView } from '@bingads-webui-campaign-react/portfolio-bid-strategy-shared';
import { NumberRange } from '@bingads-webui-campaign-legacy/bidding-strategy/viewmodel/setting';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';

export class BidStrategyManualCPCColumn extends CampaignuiBaseColumn {
  constructor({
    i18n, view, helpId = 'pop_BA_CampaignGrids_ManualCPI',
  }) {
    const title = i18n.getString('BiddingStrategyType_ManualCpc');

    super({
      name: 'DisplayBiddingStrategyManualCpc',
      property: 'BiddingScheme',
      title,
      sortable: 'DisplayBiddingStrategyManualCpc',
      type: 'number',
      helpId,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
      enableEdit: item =>
        item.BiddingScheme && item.BiddingScheme.Type === 'ManualCpc' && item.CampaignType === 'App' && item.BiddingScheme.ManualCPC,
    });
    this.i18n = i18n;
    this.view = view;
  }

  pickProperty(item) {
    return _.result(item, 'BiddingScheme', null);
  }

  template({ value }) {
    if (value && value.ManualCPC) {
      return _.isNull(value.ManualCPC) ? '-' : decimal.fromFloatToString(value.ManualCPC);
    }
    return '-';
  }

  onPrompt({
    item, newPosition,
  }) {
    // disable edit while using existing bid strategy
    if (item.BidStrategyName) {
      window.App.views.alertCenter.showError(this.i18n.getString('Target_Edit_Not_Support_Hint'));
      return undefined;
    }
    const model = cloneDeep(item);
    model['BiddingScheme/ManualCpc'] = item.BiddingScheme.ManualCPC;
    const flattenedSchema = {
      ...Campaign,
      properties: {
        ...Campaign.properties,
        'BiddingScheme/ManualCpc': Campaign.properties.BiddingScheme.schema.properties.ManualCpc,
      },
    };
    const minValue = (NumberRange && NumberRange.manualCpc && NumberRange.manualCpc.minValue) || 0.01;
    const maxValue = (NumberRange && NumberRange.manualCpc && NumberRange.manualCpc.maxValue) || 4000;
    const fieldName =
      {
        property: 'BiddingScheme/ManualCpc',
        control: manualCpcInlineEditorView,
        i18n: this.i18n,
        curTargetCpc: decimal.fromFloatToString(item.BiddingScheme.ManualCPC),
        minValue,
        maxValue,
        currencySymbol: this.i18n.getCurrencySymbol(PageContext.AccountCurrencyCode),
        currencySymbolClassName: `symbol-size-${this.i18n.getCurrencySymbol(PageContext.AccountCurrencyCode).length}`,
      };
    return InlineEditableColumnPrompt({
      position: newPosition,
      item: model,
      view: this.view,
      i18n: this.i18n,
      fieldName,
      schema: flattenedSchema,
      saveModel: (updated, editorView) => {
        if (updated['BiddingScheme/ManualCpc'] < minValue || updated['BiddingScheme/ManualCpc'] > maxValue) {
          return;
        }
        const bidObject = cloneDeep(item.BiddingScheme);
        bidObject.ManualCpc = updated['BiddingScheme/ManualCpc'];
        const toUpdated = _.defaults({
          BiddingScheme: bidObject,
        }, _.pick(this.item, 'Id'));

        jsData.Campaign
          .update(item.Id, toUpdated, { adapter: 'bulk', cacheResponse: false })
          .finally(withUiBlock(this.view.grid.gridView.$el))
          .then(() => {
            editorView.trigger('save');
            this.view.grid.gridView.refresh(true);
          })
          .catch((response) => {
            let errorMessage;
            const unexpectedError = this.i18n.getString('ErrorNumber_-1');
            if (!response || !response.errors) {
              errorMessage = unexpectedError;
            } else {
              const errors = i18nErrors.getBulkApiErrors(response.errors);
              if (!errors || !errors[0] || !errors[0].message) {
                errorMessage = unexpectedError;
              } else {
                errorMessage = errors[0].message;
              }
            }
            editorView.setErrors({
              'BiddingScheme/ManualCpc': errorMessage,
            });
          });
      },
      parentContainerSelector: '.grid-and-disclaim-container',
    });
  }
}
